module.exports = __webpack_public_path__ + "img/位图(3).9cb277f3.png";